<template>
  <div class="container page-container" v-if="dataReady">

    <h1 class="project">{{ project.name }}</h1>
    <p class="edited">Edited: <span class="date">{{prettyDate(project.edited)}}</span><br>
    Created: <span class="date">{{prettyDate(project.created)}}</span></p>

    <div class="add-project" v-if="user.isAdmin">
      <el-form :inline="true" :model="formInline" :label-position="labelPosition" class="form-inline">
        <el-form-item label="Edit Project Name">
          <el-input v-model="project.name" @change="updateName"></el-input>
        </el-form-item>
        <el-form-item label="Add Project Data">
          <input @change="updateFile" type="file" accept=".csv"/>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="getExportActionsDef()">Export <i class="el-icon-document el-icon-plus"></i></el-button>
          <el-button type="primary" @click="openDatabase()">View JSON <i class="el-icon-document el-icon-right"></i></el-button>
          <el-button type="primary" @click="hideEmptyTables = !hideEmptyTables">{{ hideEmptyTables ? "Show Empty Cells" : "Hide Empty Cells" }}</el-button>
          <el-button class="btn-delete" type="danger" @click="deleteFormVisible = true" :disabled="!user.isAdmin">Delete Project <i class="el-icon-delete el-icon-right"></i></el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column type="expand">
        <template scope="props">
          <div v-if="propertyName !== 'unit'" v-for="(value, propertyName, index) in props.row">
            <el-row v-if="hideEmptyTables && (value === undefined || value === null || value === '')">
            </el-row>
            <el-row v-else>
              <b v-if="value !== undefined && value !== null && value !== ''">{{ propertyName }}:</b>
              <b v-else><s>{{ propertyName }}:</s></b>
              <i>{{ value }}</i>
              <hr>
            </el-row>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Unit"
        prop="unit">
      </el-table-column>
      <el-table-column
        label="Status"
        prop="status">
      </el-table-column>
    </el-table>
    <br>
      <el-input
        placeholder="Enter Custom Ordering"
        :readonly="!user.isAdmin"
        v-model="input">{{ ordering }}<el-button slot="append" type="primary" @click="updateOrdering" :disabled="!user.isAdmin">Save</el-button></el-input>

    <!--<data-tables
      v-loading='loading'
      :data='project.units'
      :table-props='tprops'
      :actions-def='getExportActionsDef()'
      :search-def='getSearchDef()'
      :has-action-col='false'
      
      @filtered-data='handleFilterDataChange' v-if="project.units">

      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :fixed="item.fixed"
        :prop="item.val"
        :label="item.label"
        :width="item.width"
        :show-overflow-tooltip="item.showOverflowTooltip">
      </el-table-column>

    </data-tables>-->

    <el-dialog title="Are You Sure You Want To Delete This Project?" :visible.sync="deleteFormVisible">
      <el-form :model="form" :inline="true" :label-position="labelPosition">

        <el-button @click="deleteFormVisible = false">No Way, Get Me Out Of Here!</el-button>
        <el-button type="danger" @click="deleteProject()">Delete</el-button>

      </el-form>

    </el-dialog>

  </div>
</template>
<script>
  import CsvExport from '../helpers/CsvExport'
  import Papa from 'PapaParse'
  import moment from 'moment'
  import slugify from 'slugify'
  import lang from 'element-ui/lib/locale/lang/en'
  import locale from 'element-ui/lib/locale'
  import { db, authService } from '../helpers/helpers'
  locale.use(lang)
  var projectRef
  export default {
    name: 'project',
    data () {
      return {
        dataReady: false,
        loading: true,
        hideEmptyTables: false,
        auth: authService,
        uid: '',
        options: [{
          value: 'Available',
          label: 'Available'
        }, {
          value: 'Held',
          label: 'Held'
        }, {
          value: 'Sold',
          label: 'Sold'
        }, {
          value: 'Future',
          label: 'Future'
        }],
        value: '',
        formInline: {
          user: '',
          unitFile: ''
        },
        // datProps: [],
        // filteredData: [],
        dialogFormVisible: false,
        deleteFormVisible: false,
        labelPosition: 'top',
        form: {
          id: '',
          unitnum: '',
          floor: '',
          unit: '',
          size: '',
          size2: '',
          plan: '',
          type: '',
          file: '',
          plate: '',
          price: '',
          status: '',
          view: ''
        },
        tprops: {
          height: 'auto',
          slotScope: 'prop',
          rowStyle: function (row, rowIndex) {
            return {

            }
          }
        },
        tableProps: {
        },
        tableColumns: [],
        tableHeader: [],
        tableData: [],
        ordering: [],
        input: '',
        unitData: []
      }
    },

    created () {
      var vm = this
      this.makeTableHeader()
      this.$bindAsObject('user', db.ref('users').child(this.auth.user.uid))
      projectRef = db.ref(this.$route.path)
      this.$bindAsObject('project', projectRef)
      this.dataReady = true
      this.loading = false

      projectRef.child('units').on('value', function (snapshot) {
        vm.unitData = snapshot.val()
        vm.makeTable()
      })

      projectRef.child('ordering').on('value', function (snapshot) {
        var orderingData = snapshot.val()
        vm.input = orderingData
        vm.ordering = orderingData.split(',')
        vm.makeTable()
      })
    },

    methods: {
      makeTable () {
        var vm = this

        if (vm.unitData.length === 0) return

        let columnHeaders = vm.unitData[0]
        vm.tableColumns = vm.sortByOtherArray(Object.keys(columnHeaders), vm.ordering).map(function (val, ind, len) {
          return {
            slot: 'item',
            val: val,
            label: val,
            fixed: val === 'unit',
            width: val === 'unit' ? 75 : 200,
            showOverflowTooltip: false
          }
        })
        vm.makeTableHeader()

        function sortObject (obj) {
          return vm.sortByOtherArray(Object.keys(columnHeaders), vm.ordering).reduce((a, v) => {
            a[v] = obj[v]
            return a
          }, {})
        }

        vm.tableData = vm.unitData.map(function (value, index, self) {
          return sortObject(value)
        })
      },

      makeTableHeader () {
        this.tableHeader = this.tableColumns.map(_ => _.val)
      },

      deleteProject () {
        this.$firebaseRefs.project.remove()
        this.deleteFormVisible = false
        this.$router.push('/projects')
      },

      prettyDate (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },

      setDate () {
        let timeStamp = Date.now()
        this.$firebaseRefs.project.child('edited').set(timeStamp)
        this.$firebaseRefs.project.child('mostRecent').set(-Math.abs(timeStamp))
      },

      updateName () {
        let newName = this.project.name
        this.$firebaseRefs.project.child('name').set(newName)
        this.$firebaseRefs.project.child('slug').set(slugify(newName.toLowerCase()))
        this.setDate()
      },

      updateFile (e) {
        var vm = this
        Papa.parse(e.target.files[0], {
          header: true,
          complete (results, file) {
            vm.$firebaseRefs.project.child('units').set(results.data)
            vm.setDate()
          }
        })
        e.target.value = ''
      },

      handlePreview (file, fileList) {
        console.log(file, 'handle preview')
      },

      handleRemove (file, fileList) {
        console.log(file, fileList)
      },

      handleFilterDataChange (filteredData) {
        this.filteredData = filteredData
      },

      /* getRowActionsDef () {
        let vm = this
        return [{
          handler (row) {
            vm.dialogFormVisible = true
            vm.form = row
          },
          name: 'Edit'
        }]
      }, */

      openDatabase () {
        window.open('https:///marcatest001.firebaseio.com' + this.$route.path + '/units.json', '_blank')
      },

      updateUnits () {
        this.$firebaseRefs.project.child('units').set(this.project.units)
        this.setDate()
        this.dialogFormVisible = false
      },

      updateOrdering () {
        this.$firebaseRefs.project.child('ordering').set(this.input)
      },

      cancelUpdateUnits () {
        projectRef = db.ref(this.$route.path)
        this.$bindAsObject('project', projectRef)
        this.dialogFormVisible = false
      },

      getSearchDef () {
        return {
          show: true,
          placeholder: 'Search by Keyword',
          props: this.tableHeader
        }
      },

      getPaginationDef () {
        return {
          layout: 'total, prev, pager, next, jumper, sizes',
          pageSize: 300,
          pageSizes: [20, 50, 100, 150, 200, 300],
          currentPage: 1
        }
      },

      getExportActionsDef () {
        let columns = this.tableHeader
        let columnNames = this.tableHeader
        let timeStamp = moment(Date.now()).format()
        CsvExport(this.project.units, columns, columnNames, this.project.slug + '_' + timeStamp)
      },

      sortByOtherArray (itemArray, itemOrder) {
        function unique (arr, comparator) {
          var uniqueArr = []
          for (var i in arr) {
            var found = false
            for (var j in uniqueArr) {
              if (comparator instanceof Function) {
                if (comparator(null, arr[i], uniqueArr[j])) {
                  found = true
                  break
                }
              } else {
                if (arr[i] === uniqueArr[j]) {
                  found = true
                  break
                }
              }
            }
            if (!found) {
              uniqueArr.push(arr[i])
            }
          }
          return uniqueArr
        }

        var result = []

        itemOrder.forEach(function (key) {
          var found = false
          itemArray = itemArray.filter(function (item) {
            if (!found && item === key) {
              result.push(item)
              found = true
              return false
            } else {
              return true
            }
          })
        })

        result = unique(result.concat(itemArray), function (a, b) { return a === b })

        return result
      },

      sortColumns (a, b) {
        console.log('hello?')
        return a < b
      }
    }
  }
</script>

<style>

  h1.project {
    margin-bottom: 0;
  }

  .el-select-dropdown__item {
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  }

  .last-edited,
  .created {
    font-size:  10px;
  }

  .add-button {
    display:  block;
  }

  .pull-left {
    text-indent:  -99999px;
  }

  span.dialog-title {
    font-weight:  600 !important;
  }

  .dialog-footer .el-button {
    margin-bottom: 5px;
  }

  .btn-delete {
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// Project.vue?73349547